import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconNotNow } from '../../../../../assets/icons/svg/colored-icons/ic-colored-categorization-reload.svg';
import { ReactComponent as IconApprove } from '../../../../../assets/icons/svg/colored-icons/ic-colored-categorization-approve.svg';
import { CircleWrapper } from './GenericComponents';
import { SmallLabel } from './SmallLabel';

interface ICategorizationActionsProps {
  className?: string;
  onNotNowClick: () => void;
  onApproveClick: () => void;
  isDisabled: boolean;
}

export const CategorizationPersonalActions = ({
  className, onNotNowClick, onApproveClick, isDisabled,
}: ICategorizationActionsProps) => {
  const { t } = useTranslation('dashboardFaceliftResourcesEN');
  const disabledClassName = isDisabled ? 'opacity-30' : '';
  return (
    <div className={`h-[80px] flex justify-between items-center relative z-30 px-[8px] ${className}`}>
      <div className='relative h-full cursor-pointer' onClick={!isDisabled ? onNotNowClick : () => {}} tabIndex={0} onKeyDown={() => {}} role='button'>
        <CircleWrapper isButton className={`${disabledClassName} h-[56px] w-[56px]`}>
          <IconNotNow className={`${disabledClassName}`} data-testid='CategorizationPersonalActions__not-now-icon' />
        </CircleWrapper>
        <SmallLabel label={t('CATEGORIZATION_ACTION_NOT_NOW')} testId='CategorizationPersonalActions__action-not-now' className={`text-center mt-[5px] ${disabledClassName}`} />
      </div>
      <div className='relative h-full cursor-pointer' onClick={!isDisabled ? onApproveClick : () => {}} tabIndex={0} onKeyDown={() => {}} role='button'>
        <CircleWrapper isButton className={`${disabledClassName} h-[56px] w-[56px]`}>
          <IconApprove className={`${disabledClassName}`} data-testid='CategorizationPersonalActions__approve-icon' />
        </CircleWrapper>
        <SmallLabel label={t('CATEGORIZATION_ACTION_APPROVE')} testId='CategorizationPersonalActions__action-approve' className={`text-center mt-[5px] ${disabledClassName}`} />
      </div>
    </div>
  );
};
